import Vue from "vue";
import Router from "vue-router";
import Midgrab from "../components/Midgrab.vue";
import GrabIQ from "../components/GrabIQ.vue";
import Form from "../components/Form.vue";
import Home from "../components/Home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "Home | Gunnebo Industries"
      }
    },
    {
      path: "/calculator",
      name: "Calculator",
      component: Form,
      meta: {
        title: "Calculator | Gunnebo Industries"
      }
    },
    {
      path: "/midgrab",
      name: "Midgrab",
      component: Midgrab,
      meta: {
        title: "Midgrab | Gunnebo Industries"
      }
    },
    {
      path: "/grabiq",
      name: "GrabIQ",
      component: GrabIQ,
      meta: {
        title: "GrabIQ | Gunnebo Industries"
      }
    }
  ],
  mode: "hash"
});
